module.exports = __webpack_public_path__ + "static/media/thumb3.ee051d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/VipRoom/images/thumb3.jpg
// module id = 444
// module chunks = 0